import CloseIcon from '@mui/icons-material/Close';
import ARImage from 'components/ar-image/ar-image.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { dialogTitle } from './custom-dialog.constants';
import * as S from './custom-dialog.styles';

const CustomDialog = ({
  open,
  close,
  title,
  children,
  image,
  originalImage,
  testId = 'CustomDialog.Container',
  paperId,
  ...rest
}) => {
  const { t } = useTranslation();

  return (
    <S.Container
      fullWidth
      open={open}
      onClose={close}
      maxWidth="xs"
      PaperProps={{ 'data-testid': testId, id: paperId }}
      aria-labelledby={dialogTitle}
      {...rest}
    >
      <S.Close
        data-testid="CustomDialog.Close"
        onClick={close}
        aria-label={t('dialogs.close.ariaLabel')}
      >
        <CloseIcon />
      </S.Close>
      {image && <ARImage src={image} alt="" />}
      {originalImage && <S.OriginalImg src={originalImage} alt="" />}
      <S.Content>
        {!!title && (
          <S.Title component="h2" variant="h4" id={dialogTitle}>
            {title}
          </S.Title>
        )}
        {children}
      </S.Content>
    </S.Container>
  );
};

export default CustomDialog;
